export default {
  computed: {
    normalizedLocalizations() {
      var result={};
      for(var locType in this.localizations || {}) {
        var locValue=String(this.localizations[locType] || "");
        var locTypeFields=locType.split("|");
        var locValueFields=locValue.split("|");
        for(var i in locTypeFields) {
          if (locValueFields[i])
            result[locTypeFields[i]]=locValueFields[i];
        }
      }
      return result;
    },
  },
}
